import type {
  ComponentDefinitionTuple,
  ComponentDefinition,
} from '@app/shared/vue/global-components/types'

import modalsDefinitions from '@app/shared/vue/global-components/modals.js'
import { globalMounter } from '@app/setup/global-components'

const modal = modalsDefinitions.find(
  (definition) => definition[0] === 'auto-reconcile-modal'
) as ComponentDefinitionTuple | undefined

export default (): void => {
  if (modal) {
    const definitionMap = new Map<string, ComponentDefinition>()
    definitionMap.set(modal[0], modal[1])

    globalMounter(window.onDomLoad)(definitionMap)
  }
}
